/**
 * 数据面路径前缀（骨架，#89098）
 *
 * 取值来自设计文档 §5.0 / §6.0 的路径白名单，与 skill 的 “How an App Talks to It”
 * 表格一致。**写死为常量表，不做通用拼接** —— 网关侧同样是常量映射，两边必须对齐。
 */

import type { CloudModuleName } from './types.js';

/** 所有数据面路径的公共前缀。 */
export const CLOUD_PATH_PREFIX = '/.cloud';

/**
 * 模块 → 数据面路径前缀。
 *
 * 网关剥掉 `/.cloud/{模块}` 后还原为 TCB 原路径（auth→`/auth/**`、
 * database→`/v1/rdb/rest/**`、storage→`/v1/storages/**`），该映射是服务端职责，
 * SDK 不感知，也不要在这里镜像。
 */
export const CLOUD_MODULE_PATHS: Readonly<Record<CloudModuleName, string>> = Object.freeze({
    auth: `${CLOUD_PATH_PREFIX}/auth`,
    database: `${CLOUD_PATH_PREFIX}/database/rest`,
    storage: `${CLOUD_PATH_PREFIX}/storage`,
    llm: `${CLOUD_PATH_PREFIX}/llm`,
});
